import React from "react";
import PropTypes from "prop-types";

class TableSorter extends React.PureComponent {
  constructor(props) {
    super();
    this.state = {
      comparator: null,
      isAsc: props.defaultIsAsc,
      sortedField: null,
    };
  }

  toggleField = (comparator, sortedField) => {
    this.setState((prevState) => {
      const { defaultSortedField, defaultIsAsc } = this.props;
      const prevSortedField = prevState.sortedField || defaultSortedField;
      return {
        comparator,
        sortedField,
        isAsc:
          prevSortedField === sortedField ? !prevState.isAsc : defaultIsAsc,
      };
    });
  };

  getSortedItems = () => {
    const { items } = this.props;
    const { comparator: stateComparator, isAsc: stateIsAsc } = this.state;
    const { defaultComparator } = this.props;
    const comparator = stateComparator || defaultComparator;
    const isAsc = stateIsAsc;
    if (!items) {
      return [];
    }

    if (comparator) {
      const sorted = items.sort(comparator).slice(0);
      return isAsc ? sorted : sorted.reverse();
    }

    return items.slice(0);
  };

  render() {
    const { renderContent, defaultSortedField, defaultIsAsc } = this.props;
    const { sortedField, isAsc } = this.state;
    const sortedItems = this.getSortedItems();
    return renderContent({
      ...this.props,
      sortedItems,
      sortedField: sortedField || defaultSortedField,
      isAsc: isAsc !== null ? isAsc : defaultIsAsc,
      toggleField: this.toggleField,
    });
  }
}

TableSorter.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.arrayOf(PropTypes.any),
  renderContent: PropTypes.func.isRequired,
  defaultComparator: PropTypes.func,
  defaultIsAsc: PropTypes.bool,
  defaultSortedField: PropTypes.string,
};

TableSorter.defaultProps = {
  items: [],
  defaultComparator: null,
  defaultIsAsc: true,
  defaultSortedField: null,
};

export default TableSorter;
